import React from 'react';

export default  (props) => {
  return (
    <img src={props.src} alt="" className={props.className} width={props.size} height={props.size}/>
  )
}